import { Navigate, RouteObject } from "react-router-dom";
import { ExternalSystemAuthorizationHandlerPage } from "../pages";

const externalSystemRedirectRoutes: RouteObject[] = [
    {
        path: '/',
        element: <ExternalSystemAuthorizationHandlerPage />
    },
    {
        path: '*',
        element: <Navigate to="/" replace />
    }
]

export default externalSystemRedirectRoutes;